import { Chip } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import EventAvailableRoundedIcon from "@mui/icons-material/EventAvailableRounded";
import { colours } from "../../../StyleConstants";

interface ObjectStatus {
    label: string;
    fontColour: string;
    bgColour: string;
    icon: any;
}
export default function ValidationLabel(props: any) {
    const statusChip: Record<string, ObjectStatus> = {
        rejected: {
            label: "REJECTED",
            fontColour: colours.error.error,
            bgColour: colours.error.error20,
            icon: HighlightOffIcon,
        },
        approved: {
            label: "APPROVED",
            fontColour: colours.success.success,
            bgColour: colours.success.success20,
            icon: CheckIcon,
        },
        // "TrainingComplete" is a real backend DucStatus value (DucStatus.TRAINING_COMPLETE) - a PI
        // whose DUC is otherwise approved but has just finished their training. Without this key it
        // fell through to `default`, showing "DEFAULT" on the PI dashboard instead of "APPROVED".
        // LC-6452 follow-up: this key backs the ducStatus column specifically (PiTableRenderers'
        // GetStatusChip looks it up directly by the lowercased raw value) - the training-status
        // column has its own "completed" key below, so this one must read "APPROVED", not
        // "COMPLETED", or the DUC Status column shows the training half instead of the DUC half.
        trainingcomplete: {
            label: "APPROVED",
            fontColour: colours.success.success,
            bgColour: colours.success.success20,
            icon: CheckIcon,
        },
        expiring: {
            label: "EXPIRING",
            fontColour: colours.warning.warn,
            bgColour: colours.warning.warn20,
            icon: EventAvailableRoundedIcon,
        },
        expired: {
            label: "EXPIRED",
            fontColour: colours.error.error,
            bgColour: colours.error.error20,
            icon: HighlightOffIcon,
        },
        // LC-5487: the backend's ducStatus enum literally emits "DucExpired" (there is no
        // "Expired"; see renewalWindow.ts), and PiTableRenderers lowercases it before passing it
        // in here. Without this key it fell through to `default`, so a sub-applicant whose DUC had
        // genuinely expired was shown with a "DEFAULT" chip on the PI dashboard instead of EXPIRED.
        ducexpired: {
            label: "EXPIRED",
            fontColour: colours.error.error,
            bgColour: colours.error.error20,
            icon: HighlightOffIcon,
        },
        pending: {
            label: "PENDING",
            fontColour: colours.warning.warn,
            bgColour: colours.warning.warn20,
            icon: EventAvailableRoundedIcon,
        },
        default: {
            label: "DEFAULT",
            fontColour: colours.success.success,
            bgColour: colours.success.success20,
            icon: RotateLeftIcon,
        },
        completed: {
            label: "COMPLETED",
            fontColour: colours.success.success,
            bgColour: colours.success.success20,
            icon: CheckIcon,
        },
        notstarted: {
            label: "NOT STARTED",
            fontColour: colours.gray.gray70,
            bgColour: colours.gray.gray10,
            icon: HighlightOffIcon
        },
        // LC-5487: "NotSubmitted" is a real duc_details.status/ducStatus value (DucStatus.NOT_SUBMITTED
        // on the backend); without this key it also fell through to `default`.
        notsubmitted: {
            label: "NOT SUBMITTED",
            fontColour: colours.gray.gray70,
            bgColour: colours.gray.gray10,
            icon: HighlightOffIcon
        },
        revoked: {
            label: "REVOKED",
            fontColour: colours.error.error,
            bgColour: colours.error.error20,
            icon: HighlightOffIcon,
        },
        submitted: {
            label: "PENDING APPROVAL",
            fontColour: colours.warning.warn,
            bgColour: colours.warning.warn20,
            icon: RotateLeftIcon,
        },
        inprogress: {
            label: "PENDING APPROVAL",
            fontColour: colours.warning.warn,
            bgColour: colours.warning.warn20,
            icon: RotateLeftIcon,
        },
        traininginprogress: {
            label: "IN PROGRESS",
            fontColour: colours.warning.warn,
            bgColour: colours.warning.warn20,
            icon: RotateLeftIcon,
        },
        trainingexpiring: {
            label: "TRAINING EXPIRING",
            fontColour: colours.warning.warn,
            bgColour: colours.warning.warn20,
            icon: EventAvailableRoundedIcon,
        },
        trainingexpired: {
            label: "TRAINING EXPIRED",
            fontColour: colours.error.error,
            bgColour: colours.error.error20,
            icon: HighlightOffIcon,
        },
        declined: {
            label: "DECLINED",
            fontColour: colours.error.error,
            bgColour: colours.error.error20,
            icon: RotateLeftIcon,
        },
        envelopeexpired: {
            label: "ENVELOPE EXPIRED",
            fontColour: colours.error.error,
            bgColour: colours.error.error20,
            icon: HighlightOffIcon,
        },
        cancelled: {
            label: "CANCELLED",
            fontColour: colours.error.error,
            bgColour: colours.error.error20,
            icon: HighlightOffIcon,
        },
        ownershiptransfer: {
            label: "LEAD INVESTIGATOR CHANGE",
            fontColour: colours.warning.warn,
            bgColour: colours.warning.warn20,
            icon: RotateLeftIcon,
        },

    };

    // If status is declined and declined_by is EnvelopeExpiry, show Envelope Expired
    let statusKey = props.state;
    if (props.state === 'declined' && props.declined_by === 'EnvelopeExpiry') {
        statusKey = 'envelopeexpired';
    }

    const statusInfo = statusChip[statusKey] ?? statusChip.default;
    const styles = { color: statusInfo.fontColour };

    return (
        <>
            <Chip
                icon={<statusInfo.icon styles={styles} />}
                label={statusInfo.label}
                sx={{
                    backgroundColor: statusInfo.bgColour,
                    color: statusInfo.fontColour,
                    height: 22,
                    borderRadius: 24,
                    fontSize: 10,
                    borderWidth: 0,
                    fontWeight: "600",
                }}
            />
        </>
    );
}
